import React, { useState } from "react";
import { Tooltip, tooltipClasses } from "@mui/material";
import { FiChevronsDown, FiChevronsUp } from "react-icons/fi";
import DealDetailsPayment from "./DealDetailsPayment";
import {
  convertSecondsToHMS,
  convertToUTCString,
} from "../../../../utils/helpers/helper";
import { useSelector } from "react-redux";
import { useFunctionalityAccess } from "../../../../core/common/wrapper/HasFunctionalityAccess";

const DealDetailsSidebar = ({ dealData: deal }) => {
  const [openAccordion, setOpenAccordion] = useState(true);
  const toggleAccordion = () => {
    setOpenAccordion(!openAccordion);
  };

  const hasZoomAccess = useFunctionalityAccess("zoomSetting");

  return (
    <div className="col-12 theiaStickySidebar">
      <div className="card">
        <div className="card-body p-3">
          <div className="">
            <div className="d-flex justify-content-between align-items-center">
              {/* Status Information */}
              <h6 className="mb-1 fw-semibold fs-5 text-decoration-underline">
                Status
              </h6>
              <Tooltip
                title={openAccordion ? "Collapse Details" : "Expand Details"}
              >
                <div style={{ cursor: "pointer" }} onClick={toggleAccordion}>
                  {openAccordion ? (
                    <FiChevronsUp size={18} />
                  ) : (
                    <FiChevronsDown size={18} />
                  )}
                </div>
              </Tooltip>
            </div>
          </div>

          <div className="row mb-2 gx-5 ">
            {deal?.currentStatus?.name && (
              <div className="d-flex justify-content-between col-md-6">
                <span className="col-6 fw-bold">Current Status:</span>
                <span className="col-6 text-capitalize">
                  {deal?.currentStatus?.name}
                </span>
              </div>
            )}
            <div className="d-flex justify-content-between col-md-6">
              <span className="col-6 text-capitalize fw-bold">
                Probability:
              </span>
              <span className="col-6 text-capitalize">
                {deal?.probability || "N/A"}
              </span>
            </div>
          </div>
          <hr />

          {openAccordion && (
            <>
              {hasZoomAccess && (
                <>
                  {/* Integrations */}
                  <div className="d-flex align-items-center gap-2 mb-1">
                    <h5 className=" fw-semibold fs-5 text-decoration-underline mb-1">
                      Zoom Webinar
                    </h5>

                    {deal?.meetingDetails &&
                      deal?.meetingStatus === "attended" && (
                        <span className="fw-italic fw-semibold">
                          <em>
                            (
                            <span>
                              Attended Zoom for:{" "}
                              {convertSecondsToHMS(
                                deal?.meetingDetails?.duration
                              )}
                            </span>
                            {" | "}
                            <span>
                              Joined at:{" "}
                              {convertToUTCString(
                                deal?.meetingDetails?.joinTime
                              )}
                            </span>
                            {" | "}
                            <span>
                              Left at:{" "}
                              {convertToUTCString(
                                deal?.meetingDetails?.leaveTime
                              )}
                            </span>
                            )
                          </em>
                        </span>
                      )}
                  </div>

                  <div className="input-group align-items-center">
                    <div className="input-group-prepend">
                      <Tooltip placement="bottom" title="Zoom Meeting Status">
                        <span className="input-group-text border-0 bg-transparent p-0">
                          <img
                            src="/assets/img/bsm/zoom-50.png"
                            alt="Zoom"
                            style={{
                              width: "36px",
                              height: "36px",
                              objectFit: "cover",
                              border: "1px solid #ddd",
                            }}
                            className="rounded-start-2"
                          />
                        </span>
                      </Tooltip>
                    </div>

                    <input
                      className="form-control form-control-sm text-capitalize pt-0 rounded-0 fs-6"
                      style={{
                        height: "36px",
                        maxWidth: "160px",
                      }}
                      value={deal?.meetingStatus?.split("-").join(" ")}
                    />
                  </div>
                  <hr />
                </>
              )}

              {/* Interested Product */}
              <h6 className="mb-1 fw-semibold fs-5 text-decoration-underline">
                Interested Product
              </h6>
              <div className="row mb-2 gx-5 ">
                <div className="d-flex justify-content-between col-md-6">
                  <span className="col-6 fw-bold">Product Category:</span>
                  <span className="col-6 text-capitalize">
                    {deal?.productCategory || deal?.productCategory || "N/A"}
                  </span>
                </div>
                <div className="d-flex justify-content-between col-md-6">
                  <span className="col-6 fw-bold">Product Name:</span>
                  <span className="col-6 text-capitalize">
                    {deal?.productInterested?.name ||
                      deal?.productInterested ||
                      "N/A"}
                  </span>
                </div>
              </div>
              <hr />

              <DealDetailsPayment deal={deal} />

              {/* Additional Information */}
              <h6 className="mb-2 fw-semibold fs-5 text-decoration-underline">
                Additional Information
              </h6>
              <ul className="row mb-3 gx-5">
                <li className="d-flex justify-content-between mb-1 col-md-6">
                  <span className="col-6 fw-bold">Lead Source:</span>
                  <span className="col-6 text-capitalize">
                    {deal?.leadSource || "N/A"}
                  </span>
                </li>

                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Question 1:</span>
                  <span className="col-6 text-capitalize">
                    {deal?.question1 || "N/A"}
                  </span>
                </li>

                <li className="d-flex justify-content-between mb-1 col-md-6">
                  <span className="col-6 fw-bold">Reference Source:</span>
                  <span className="col-6 text-capitalize">
                    {deal?.referenceSource || "N/A"}
                  </span>
                </li>

                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Question 2:</span>
                  <span className="col-6 text-capitalize">
                    {deal?.question2 || "N/A"}
                  </span>
                </li>

                <li className="d-flex justify-content-between mb-1 col-md-6">
                  <span className="col-6 fw-bold">Business Type:</span>
                  <span className="col-6 text-capitalize">
                    {deal?.businessType || "N/A"}
                  </span>
                </li>

                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Question 3:</span>
                  <span className="col-6 text-capitalize">
                    {deal?.question3 || "N/A"}
                  </span>
                </li>
              </ul>

              <ul className="row mb-3 gx-5">
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Alternate Phone Number:</span>
                  <span className="col-6 text-capitalize">
                    {deal?.alternateNumber || "N/A"}
                  </span>
                </li>

                <li className="d-flex justify-content-between mb-1 col-md-6">
                  <span className="col-6 fw-bold">Client Code:</span>
                  <span className="col-6 text-capitalize">
                    {deal?.clientCode || "N/A"}
                  </span>
                </li>

                <li className="d-flex justify-content-between mb-1 col-md-6">
                  <span className="col-6 fw-bold">Company:</span>
                  <span className="col-6 text-capitalize">
                    {deal?.ofCompany?.name}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Deal Assigned To:</span>
                  <span className="col-6 text-capitalize">
                    {deal?.assignedTo?.name || "N/A"}
                  </span>
                </li>
                <li className="d-flex justify-content-between mb-1 col-md-6">
                  <span className="col-6 fw-bold">Last Modified:</span>
                  <span className="col-6">
                    {convertToUTCString(deal?.lastActivityDate)}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Last Modified By:</span>
                  <span className="col-6 text-capitalize">
                    {deal?.lastUpdationBy?.name || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Occupation:</span>
                  <span className="col-6">{deal?.occupation || "N/A"}</span>
                </li>

                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Preferred Language:</span>
                  <span className="col-6 text-capitalize">
                    {deal?.language || "N/A"}
                  </span>
                </li>
              </ul>

              <ul className="row mb-3 gx-5">
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Reference Source:</span>
                  <span className="col-6 text-capitalize">
                    {deal?.referenceSource || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">
                    Reference By Franchise Code:
                  </span>
                  <span className="col-6 text-capitalize">
                    {deal?.referenceByFranchiseCode || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">
                    Reference By Franchise Mobile:
                  </span>
                  <span className="col-6 text-capitalize">
                    {deal?.referenceByFranchiseMobile || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">
                    Reference By Franchise Email:
                  </span>
                  <span className="col-6 text-capitalize">
                    {deal?.referenceByFranchiseEmail || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">
                    Reference By Franchise Name:
                  </span>
                  <span className="col-6 text-capitalize">
                    {deal?.referenceByFranchiseName || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Franchise Details:</span>
                  <span className="col-6 text-capitalize">
                    {deal?.franchiseDetails || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Franchise RM:</span>
                  <span className="col-6 text-capitalize">
                    {deal?.franchiseRM || "N/A"}
                  </span>
                </li>
              </ul>
              <hr />

              <h6 className="mb-1 fw-semibold fs-5 text-decoration-underline">
                Marketing Information
              </h6>
              <ul className="row mb-3">
                {/* UTM fields */}
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">UTM Medium:</span>
                  <span className="col-6 text-capitalize">
                    {deal?.utmMedium || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">UTM Source:</span>
                  <span className="col-6 text-capitalize">
                    {deal?.utmSource || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">UTM Content:</span>
                  <span className="col-6 text-capitalize">
                    {deal?.utmContent || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">UTM Term:</span>
                  <span className="col-6 text-capitalize">
                    {deal?.utmTerm || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">UTM Campaign:</span>
                  <span className="col-6 text-capitalize">
                    {deal?.utmCampaign || "N/A"}
                  </span>
                </li>

                {/* Other marketing info */}
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Data Sources:</span>
                  <span className="col-6 text-capitalize">
                    {deal?.dataSources || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">IP Address:</span>
                  <span className="col-6">{deal?.ipAddress || "N/A"}</span>
                </li>

                {/* Social/Ads info */}
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Ad Account:</span>
                  <span className="col-6">{deal?.adAccount || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Ad Campaign:</span>
                  <span className="col-6">{deal?.adCampaign || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Ad Set:</span>
                  <span className="col-6">{deal?.adSet || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Ads:</span>
                  <span className="col-6">{deal?.ads || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Lead Form:</span>
                  <span className="col-6">{deal?.leadForm || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Facebook Page:</span>
                  <span className="col-6">{deal?.facebookPage || "N/A"}</span>
                </li>

                {/* IDs */}
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Ad Account ID:</span>
                  <span className="col-6">{deal?.adAccountId || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Ads Name:</span>
                  <span className="col-6">{deal?.adsName || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Campaign Name:</span>
                  <span className="col-6">{deal?.campaignName || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Ad Campaign ID:</span>
                  <span className="col-6">{deal?.adCampaignId || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Ad Set ID:</span>
                  <span className="col-6">{deal?.adSetId || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Ad ID:</span>
                  <span className="col-6">{deal?.adId || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Lead Form ID:</span>
                  <span className="col-6">{deal?.leadFormId || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Facebook Page ID:</span>
                  <span className="col-6">{deal?.facebookPageId || "N/A"}</span>
                </li>

                {/* Extra business/social fields */}
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Brand:</span>
                  <span className="col-6">{deal?.brand || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Lead ID (Social):</span>
                  <span className="col-6">{deal?.leadIdSocial || "N/A"}</span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Business Lead Type:</span>
                  <span className="col-6">
                    {deal?.businessLeadType || "N/A"}
                  </span>
                </li>
                <li className="col-md-6 d-flex justify-content-between mb-1">
                  <span className="col-6 fw-bold">Platform:</span>
                  <span className="col-6">{deal?.platform || "N/A"}</span>
                </li>
              </ul>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default DealDetailsSidebar;
